import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ScheduleCardData } from './schedule-card.types';

@Component({
  selector: 'common-schedule-card',
  templateUrl: './schedule-card.component.html',
  styleUrls: ['./schedule-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleCardComponent implements OnChanges {
  @Input() data: ScheduleCardData = {
    dayLabel: 'Lunes',
    slots: [{ fromLabel: 'Desde: 00:00 mm', toLabel: 'Hasta: 00:00 mm' }],
  };

  /** Texto cuando no hay franjas (evita layout roto). */
  @Input() emptyLabel = '—';

  public indicatorClasses: string[] = [];
  public timesClasses: string[] = [];

  constructor() {
    this.syncClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.syncClasses();
    }
  }

  private syncClasses(): void {
    const unavailable = this.data?.isAvailable === false;
    this.indicatorClasses = unavailable ? ['munily-schedule-card__indicator--unavailable'] : [];
    this.timesClasses = unavailable ? ['munily-schedule-card__times--center'] : [];
  }
}
